import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RecommendationState } from '@urbannex/product-multi-recommender';
import { AssistantConfig } from '@urbannex/view-containers';
import { BehaviorSubject, Subscription } from 'rxjs';
import { RecommendationServicesService } from './services/recommendation-services.service';


@Component({
  selector: 'ubs-recommender-chat-container',
  template: `
    <ng-container *ngIf="assistantConfig;else noAssistantConfig">
      <div class="input-output-container">
        <div class="input-container">
          <ng-container [ngSwitch]="path">
            <ng-container *ngSwitchCase="'stores/store'">
              <ubs-catalog-recommender class="chat-wrapper" [assistantConfig]="assistantConfig"></ubs-catalog-recommender>
            </ng-container>
            <ng-container *ngSwitchCase="'products/product'">
              <ubs-recommendation-chat class="chat-wrapper" [assistantConfig]="assistantConfig"></ubs-recommendation-chat>
            </ng-container>       
          </ng-container>
        </div>
        <div class="output-container" [ngClass]="{ 'collapsed': !hasSelections }">
          <ubs-output-panel class="chat-wrapper"></ubs-output-panel>
        </div>
      </div>
      
    </ng-container>
    <ng-template #noAssistantConfig>
      <div>
        <p>
          No assistant config provided!
        </p>
        <p>
          Please provide an assistant config to use the recommender chat.
        </p>
      </div>
    </ng-template>
  `,
  styles: [
    `.input-output-container{
      width:100%;
      height:100%;
      display:flex;
      flex-direction:row;
    }
    .input-container{
      flex:1;
      height:100%;
      display:flex;
      flex-direction:column;
    }
    .output-container{
      flex:1;
    }
    .output-container.collapsed{
      display:none;
    }
    .chat-wrapper {
      width:100%;
      height:100%;
    }`
  ]
})
export class RecommenderChatComponent implements OnChanges{
  @Input() assistantConfig:AssistantConfig;
  state!: RecommendationState;
  private stateSubscription!: Subscription;
  name:string;                              //The name of the assistant
  assistantDescription:string;             //The description for the assistant
  path:string;

  // Emits true if any category is selected or indeterminate
  private anyCategorySelectedSubject = new BehaviorSubject<boolean>(false);
  anyCategorySelected$ = this.anyCategorySelectedSubject.asObservable();

  readonly hasSelections$ = this.chatRecommenderState.hasSelections$;
  hasSelections:boolean;

  constructor(private chatRecommenderState:RecommendationServicesService){
    this.hasSelections$.subscribe((hasSelections:boolean) => {
      this.hasSelections = hasSelections;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['assistantConfig']) {
        if(this.assistantConfig != undefined){
          console.log(this.assistantConfig);
          this.name = this.assistantConfig?.name;
          this.assistantDescription = this.assistantConfig?.capabilities[0].description
          if(this.assistantConfig?.path != undefined){
            this.path = this.assistantConfig?.path;
          }
        }
        
        
        //this.context.setAssistantConfig(this.assistantConfig);
      }
    }
}
